<template>
  <div id="banner">
    <img
      class="banner-title-pc"
      @load="titleLoad"
      src="../assets/images/banner-title-pc.png"
    />
    <img
      class="banner-title-mobile"
      @load="titleLoad"
      src="../assets/images/banner-title-mobile.png"
    />
    <img
      class="banner-kv-pc"
      @load="kvLoad"
      src="../assets/images/banner/rightbg-pc.png"
    />
    <img
      class="banner-kv-foot-pc"
      @load="kvLoad"
      src="../assets/images/banner/footbg-pc.png"
    />
    <!--style="position: absolute; height: 100vh; right: 0"-->
    <!--    <video-->
    <!--      class="banner-video-pc"-->
    <!--      :style="fixStyle"-->
    <!--      ref="videoBg"-->
    <!--      muted="muted"-->
    <!--      autoplay="autoplay"-->
    <!--      loop="loop"-->
    <!--      src="//1500010779.vod2.myqcloud.com/6ca9a800vodcq1500010779/7a845c52387702299072014475/YLlGuLZ5GMcA.mp4"-->
    <!--    ></video>-->

    <!--    <img-->
    <!--      class="banner-kv-pc"-->
    <!--      @load="kvLoad"-->
    <!--      src="../assets/images/banner.gif"-->
    <!--    />-->
    <img
      class="banner-kv-mobile"
      @load="kvLoad"
      src="../assets/images/kv-mobile-home.png"
    />
    <div class="btn-box" v-if="status === 1">
      <div class="btn1 flex justify-center align-center" @click="didClick_btn">
        已报名
      </div>
    </div>
    <div class="btn-box" v-if="status === 2">
      <div class="btn1 flex justify-center align-center" @click="didClick_btn">
        已报名
      </div>
    </div>
    <div class="btn-box" v-if="status === 3">
      <div
        class="btn1 flex justify-center align-center cs"
        @click="didClick_btn"
      >
        报名线上参会
      </div>
    </div>
    <div v-if="showPop" class="pop">
      <div class="pop_shadow cs" @click="closePop"></div>

      <div class="pop_block flex flex-direction align-center justify-center">
        <img
          class="closeImg2 cs"
          src="../assets/images/personal/close.png"
          @click="closePop"
        />
        <img class="qrcodeImg" :src="qrcodeImg" />
        <div class="text">
          扫描二维码进入小程序<br />查看您的专属电子卡证<br />开启便捷服务新体验
        </div>
      </div>
      <!--      <div class="pop_QRcode flex flex-direction align-center">-->
      <!--        <img class="closeImg2 cs" :src="closeImg2" @click="closePop" />-->
      <!--        <div class="foot">-->
      <!--          <div class="QRcode flex align-start justify-center">-->
      <!--            <img :src="qrcodeImg" />-->
      <!--          </div>-->
      <!--          <img class="foot_img" :src="footImg" />-->
      <!--          <div class="text">-->
      <!--            扫描二维码进入小程序<br />查看您的专属电子卡证<br />开启便捷服务新体验-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>
<script>
import { $config } from "../conf";
import Cookie from "js-cookie";
let _ = require("lodash");
export default {
  name: "Banner",
  data() {
    return {
      fixStyle: "",
      status: 3, //  // 1: 线下会已报名 我的电子卡证 已预约直播 2： 线上会已报名  报名线下参会 已预约直播 3： 未报名  我的电子卡证 已预约直播
      showPop: false, //二维码弹窗显隐
      qrcodeImg: require("../assets/images/personal/miniprogram.jpg"),
      footImg: require("../assets/images/personal/Group 113.png"),
      closeImg2: require("../assets/images/personal/Group 111.png"),
      titleImageLoad: false,
      kvImageLoad: false,
    };
  },
  mounted() {
    this.status = this.$store.state.userInfo.AttendanceStatus || 3;
    this.$bus.$on("updateStatus", (res) => {
      this.status = res;
    });
    window.addEventListener(
      "resize",
      _.debounce(
        () => {
          this.setVideoSize();
        },
        1000,
        false
      ),
      true
    );
    this.setVideoSize();
  },
  destroyed() {
    this.$bus.$off("updateStatus");
  },
  methods: {
    setVideoSize() {
      const windowWidth = document.body.clientWidth;
      const windowHeight = document.body.clientHeight;
      const windowAspectRatio = windowHeight / windowWidth;
      let videoWidth;
      let videoHeight;
      if (windowAspectRatio < 0.5625) {
        videoWidth = windowWidth;
        videoHeight = videoWidth * 0.5625;
        this.fixStyle = {
          height: windowWidth * 0.5625 + "px",
          width: windowWidth + "px",
          marginTop: windowHeight - windowWidth * 0.5625 + "px",
        };
      } else {
        videoHeight = windowHeight;
        videoWidth = videoHeight / 0.5625;
        this.fixStyle = {
          height: windowHeight + "px",
          width: windowHeight / 0.5625 + "px",
        };
      }
    },
    didClick_btn() {
      const { signOnlineUrl } = $config;
      let channel = Cookie.get("channel");
      switch (this.status) {
        case 1:
        case 2:
          // var h = document.documentElement.clientWidth; //获取页面可见宽度
          //
          // window._hw("send", "action", "index_electronic_card_click");
          // if (h < 992) {
          //   //跳转小程序
          //   //TODO 需要加手机号
          //   window.location.href = `${$config.homePage}ticket.html?type=2&uid=`;
          // } else {
          //   //显示二维码弹窗
          //   this.showPop = true;
          // }
          break;
        case 3:
          window._hw("send", "action", "index_meeting_register_click");
          window.location.href = `${signOnlineUrl}?channel=${
            channel || ""
          }&returnUrl=${encodeURIComponent(location.href)}`;
          break;
      }
    },
    //点击弹窗关闭按钮
    closePop() {
      this.showPop = false;
    },
    //图片加载
    titleLoad() {
      this.titleImageLoad = true;
      if (this.kvImageLoad) {
        this.$bus.$emit("loadingShow", true);
      }
    },
    kvLoad() {
      this.kvImageLoad = true;
      if (this.titleImageLoad) {
        this.$bus.$emit("loadingShow", true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#banner {
  width: 100%;

  .banner-title-pc,
  .banner-title-mobile,
  .banner-kv-pc,
  .banner-kv-mobile {
    display: none;
  }

  .btn-box {
    .btn1 {
      background: #b4251e;
      opacity: 1;
      color: #ffffff;
      line-height: 24px;
    }

    .btn2 {
      background: #b4251e;
      opacity: 1;
      color: #ffffff;
      line-height: 24px;
    }
  }
}

@media screen and (max-width: 992px) {
  #banner {
    background: rgb(230, 232, 246);
    height: 900px;
    position: relative;

    .banner-video-pc {
      display: none;
    }

    .banner-kv-mobile {
      //width: 100%;
      //position: relative;
      //margin: 22px auto 0;
      //display: block;
      width: 704px;
      height: 750px;
      position: absolute;
      right: 0;
      top: 310px;
      display: block;
    }

    .banner-title-mobile {
      width: 564px;
      margin: 160px auto 0;
      position: relative;
      display: block;
    }

    .btn-box {
      position: absolute;
      top: 270px;
      width: 100%;
      display: flex;
      justify-content: center;

      .btn1 {
        width: 230px;
        height: 60px;
        font-size: 26px;
      }

      .btn2 {
        margin-left: 22px;
        width: 230px;
        height: 60px;
      }
    }
  }
}

//PC
@media screen and (min-width: 992px) {
  //banner begin
  #banner {
    width: 100vw;
    height: 720px;
    background: rgb(230, 232, 246);
    overflow: hidden;
    //background-image: url("../assets/images/banner-bg.png");
    background-size: 100vw 100vh;
    background-repeat: no-repeat;
    background-position: 100% 0;
    position: relative;

    .banner-kv-pc {
      width: 821px;
      height: 703px;
      position: absolute;
      bottom: 0;
      right: 0;
      display: block;
    }
    .banner-kv-foot-pc {
      width: 100%;
      height: 174px;
      position: absolute;
      bottom: 0;
      right: 0;
    }

    .banner-title-pc {
      width: 600px;
      height: 228px;
      top: 155px;
      left: 210px;
      position: absolute;
      display: block;
      z-index: 1;
    }

    .btn-box {
      position: absolute;
      justify-content: flex-start;
      top: 424px;
      left: 210px;
      font-size: 18px;
      .btn1 {
        width: 150px;
        height: 40px;
      }

      .btn2 {
        margin-left: 24px;
        width: 150px;
        height: 40px;
      }
    }

    .pop {
      position: fixed;
      width: 100vw;
      height: 100vh;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: $z-index-banner;

      .pop_QRcode {
        z-index: 100;
        width: 380px;
        height: 304px;
        position: absolute;
        left: calc(50vw - 130px);
        top: calc(50vh - 152px);

        .closeImg2 {
          width: 29px;
          height: 29px;
          position: absolute;
          right: -15px;
          top: -30px;
          cursor: pointer;
        }

        .foot {
          width: 260px;
          height: 174px;
          position: relative;
          z-index: 9;
          background-color: #ededed;
          bottom: -150px;

          .QRcode {
            z-index: 9;
            width: 213px;
            height: 208px;
            padding-top: 18px;
            background-color: rgba(227, 233, 245, 1);
            opacity: 1;
            position: absolute;
            top: -150px;
            left: 23px;

            img {
              width: 157px;
              height: 158px;
            }
          }

          .foot_img {
            width: 260px;
            height: 147px;
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 10;
          }

          .text {
            width: 222px;
            height: 72px;
            margin-bottom: 30px;
            font-size: 14px;
            font-family: Microsoft YaHei-Light;
            font-weight: 400;
            color: #333333;
            line-height: 25px;
            position: absolute;
            left: 19px;
            bottom: 0;
            z-index: 11;
            text-align: center;
          }
        }
      }

      .pop_shadow {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: $z-index-banner;
        background: rgba(0, 0, 0, 0.5);
        pointer-events: none;
      }

      .pop_block {
        width: 380px;
        height: 344px;
        background: #ffffff;
        opacity: 1;
        border: 1px solid;
        border-image: linear-gradient(
            164deg,
            rgba(239, 239, 239, 1),
            rgba(235, 235, 235, 0)
          )
          1 1;
        filter: blur(undefinedpx);
        z-index: 100;
        position: absolute;
        left: calc(50vw - 190px);
        top: calc(50vh - 172px);
        background-image: url("../assets/images/personal/image 50.png");
        background-size: 166px 110px;
        background-repeat: no-repeat;
        background-position: 0 100%;

        .closeImg2 {
          width: 14px;
          height: 14px;
          position: absolute;
          right: 21px;
          top: 27px;
          cursor: pointer;
        }

        .qrcodeImg {
          width: 200px;
          height: 200px;
        }

        .text {
          width: 308px;
          height: 75px;
          margin-top: 20px;
          font-size: 14px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;
          color: #333333;
          line-height: 25px;
          text-align: center;
        }
      }
    }
  }
  //banner end
}

@media (aspect-ratio: 700/701) {
  #banner {
    height: calc(100vh + 100px);

    .banner-title-mobile {
      width: 564px;
      margin: 100px auto 0;
      position: relative;
      display: block;
    }
  }
}
</style>
